import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {AppConfigPage} from './app-config';
import {TranslateModule} from "@ngx-translate/core";
import {ComponentsModule} from "../../components/components.module";
import {HeaderTitleComponentModule} from '../../components/header-title/header-title.module';

@NgModule({
  declarations: [
    AppConfigPage,
  ],
  imports: [
    ComponentsModule,
    HeaderTitleComponentModule,
    IonicPageModule.forChild(AppConfigPage),
    TranslateModule.forChild()
  ],
})
export class AppConfigPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/app-config/app-config.module.ts